import { request } from '../utils/request.js'

// 相关资讯列表
export const newsList = (parms) => {
    return request({
        url: 'ow/api.Archives/index',
        method: 'get',
        params: parms
    })
}

// 资讯详情
export const newsDetail = (parms) => {
    return request({
        url: 'ow/api.Archives/read',
        method: 'get',
        params: parms
    })
}

// 商品分类列表
export const proList = (parms) => {
    return request({
        url: 'ow/api.Product/index',
        method: 'get',
        params: parms
    })
}

// 产品分类
export const proSort = (parms) => {
    return request({
        url: 'ow/api.Product/category',
        method: 'get',
        params: parms
    })
}

// 产品详情
export const proDetail = (parms) => {
    return request({
        url: 'ow/api.Product/detail',
        method: 'get',
        params: parms
    })
}

// 推荐产品
export const hotPro = (parms) => {
    return request({
        url: 'ow/api.Product/recommend',
        method: 'get',
        params: parms
    })
}

// 首页 banner 图
export const indexBanner = (parms) => {
    return request({
        url: 'banner/api.Index/index',
        method: 'get',
        params: parms
    })
}

// 店铺地图
export const map = (parms) => {
    return request({
        url: 'ow/api.Index/shopMap',
        method: 'get',
        params: parms
    })
}

// 网站设置内容
export const baseInfo = (parms) => {
    return request({
        url: 'ow/api.Page/contentList',
        method: 'get',
        params: parms
    })
}

// 留言咨询
export const msgConsult = (parms) => {
    return request({
        url: 'ow/api.Message/post',
        method: 'post',
        params: parms
    })
}


